import { Reducer } from 'redux';
import { UserModel } from '../../models/user.model';
import { AuthService } from '../../services/auth.service';
import { UserActions, UserActionTypes } from '../actions/user.action';

export interface UserState {
    readonly user?: UserModel;
    readonly isLoggined?: boolean;
}

const initialUserState: UserState = {
    user: AuthService.getUserInfo(),
    isLoggined: AuthService.isLoggedIn()
};

export const userReducer: Reducer<UserState, UserActions> = (state = initialUserState, action) => {
    switch (action.type) {
        case UserActionTypes.GET_USER_INFO: {
            return {
                ...state,
                user: action.user
            };
        }
        case UserActionTypes.SET_ISLOGINED: {
            return {
                ...state,
                isLoggined: action.isLoggined
            };
        }
        default:
            return state;
    }
};